import {
  BasePaginateParamsSchema,
  BasePaginateResultSchema,
} from '@/api/common.ts'
import { z } from 'zod'

export enum PlanningAcknowledgmentStatus {
  Pending,
  Acknowledged,
  Bypassed,
}

export enum QcHoldType {
  RawMaterial,
  RawMaterialInProcess,
  FinishedGoods,
  InProcess,
  FinishedGoodsInProduction,
}

export enum DocumentStatus {
  Draft = 1,
  Posted = 2,
  Completed = 3,
  Cancelled = 4,
}

export const Qc8015SearchParamsSchema = z
  .object({
    itemId: z.number().optional(),
    dateFrom: z.coerce.date().optional(),
    dateTo: z.coerce.date().optional(),
  })
  .merge(BasePaginateParamsSchema)

export type Qc8015SearchParams = z.infer<typeof Qc8015SearchParamsSchema>

export const Qc8015SearchResultModelSchema = z.object({
  id: z.string(),
  number: z.string(),
  date: z.coerce.date(),
  item: z.object({
    itemId: z.number(),
    lotNo: z.string(),
    lotDate: z.coerce.date(),
    mold: z.string(),
    unit: z.string(),
  }),
  qty: z.number(),
  type: z.nativeEnum(QcHoldType),
  problem: z.object({
    isRawMaterialProblem: z.boolean(),
    isComponentProblem: z.boolean(),
    appearances: z.array(z.string()).optional(),
    functionalities: z.array(z.string()).optional(),
    appearance: z.string(),
    functionality: z.string(),
    note: z.string().optional(),
  }),
  status: z.nativeEnum(DocumentStatus),
  planningAcknowledgmentStatus: z.nativeEnum(PlanningAcknowledgmentStatus),
  documentType: z.enum(['MRR', 'NCR']).nullable().optional(),
  createdAt: z.coerce.date(),
})

export type Qc8015SearchResultModel = z.infer<
  typeof Qc8015SearchResultModelSchema
>

export const Qc8015SearchResultSchema = z
  .object({
    items: z.array(Qc8015SearchResultModelSchema),
  })
  .merge(BasePaginateResultSchema)

export type Qc8015SearchResult = z.infer<typeof Qc8015SearchResultSchema>
